<template>
  <ul class="gfr-menu-list">
    <slot />
  </ul>
</template>
<script lang="ts" setup></script>
